(() => {
  const init = () => {
    if (document.querySelector('.naturstein-mobile-price')) return true;
    const messages = document.querySelector('[data-mn24-price-label]');
    const info = document.querySelector('product-info');
    const form = info?.querySelector('product-form form');
    const source = info?.querySelector('.price__container');
    if (!messages || !form || !source || !info.querySelector('[data-live-options]')) return;
    info.classList.add('naturstein-configured-product');
    const sourceLabel = document.createElement('span');
    sourceLabel.className = 'naturstein-configured-price-label';
    source.prepend(sourceLabel);

    const bar = document.createElement('aside');
    bar.className = 'naturstein-mobile-price';
    bar.hidden = true;
    bar.setAttribute('aria-label', messages.dataset.mn24PriceLabel);
    const text = document.createElement('div');
    const label = document.createElement('span');
    label.textContent = messages.dataset.mn24PriceLabel;
    const amount = document.createElement('strong');
    amount.setAttribute('role', 'status');
    amount.setAttribute('aria-live', 'polite');
    text.append(label, amount);
    bar.append(text);
    const space = document.createElement('div');
    space.className = 'naturstein-mobile-price-space';
    space.setAttribute('aria-hidden', 'true');
    document.body.append(bar, space);

    let height = 88;
    let scheduled = false;
    let fullHeight = window.visualViewport?.height || window.innerHeight;
    const plain = (value) => {
      const template = document.createElement('template');
      template.innerHTML = value;
      return template.content.textContent.trim();
    };
    const update = () => {
      scheduled = false;
      const viewport = window.visualViewport;
      const viewportHeight = viewport?.height || window.innerHeight;
      const busy = form.hasAttribute('data-lpo-pending');
      const price = form.dataset.lpoFinalPrice;
      info.toggleAttribute('data-configuration-pending', busy);
      sourceLabel.textContent = busy ? messages.dataset.mn24PricePending : messages.dataset.mn24PriceLabel;
      const active = document.activeElement;
      const typing = active?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]');
      if (!typing) fullHeight = Math.max(fullHeight, viewportHeight);
      const keyboard = typing && (fullHeight - viewportHeight > 120 || (viewport && viewport.height < window.innerHeight * 0.78));
      const drawer = document.querySelector('cart-drawer.active, menu-drawer details[open], dialog[open]');
      const sourceAbove = source.getBoundingClientRect().bottom <= 0;
      const previewSpace = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mn24-preview-space')) || 0;
      const controls = Array.from(info.querySelectorAll('.cl-po--error, button[name="add"], quantity-input'));
      if (active?.matches('input, select, textarea')) controls.push(active);
      const overlap = Array.from(controls).some((control) => {
        const rect = control.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > viewportHeight - previewSpace - height &&
          rect.top < viewportHeight - previewSpace && getComputedStyle(control).visibility !== 'hidden';
      });
      const show = window.matchMedia('(max-width: 749px)').matches && sourceAbove &&
        !keyboard && !drawer && !overlap && (busy || Boolean(price));
      bar.hidden = !show;
      if (show) {
        amount.textContent = busy ? messages.dataset.mn24PricePending : plain(price);
        bar.setAttribute('aria-busy', String(busy));
        if (!busy) bar.removeAttribute('aria-busy');
        height = Math.ceil(bar.getBoundingClientRect().height);
      }
      space.style.height = show ? `${height + previewSpace}px` : '0px';
      document.documentElement.style.setProperty('--mn24-price-space', show ? `${height + previewSpace + 12}px` : '0px');
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    form.addEventListener('naturstein:lpo-state', update);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('scroll', schedule);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', schedule);
    new MutationObserver(schedule).observe(document.body, {
      attributes: true, subtree: true, attributeFilter: ['class', 'open']
    });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(bar);
    update();
    return true;
  };
  // LPO roots can arrive after DOMContentLoaded; retry on actual app completion.
  window.addEventListener('options:rendered', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
